export default __webpack_public_path__ + "static/media/pricingimage.d61c7743.png";